import 'slick-carousel';
import 'slick-carousel/slick/slick.css';

export const sliderTestimonial = () => {
    if($('.section-testimonials-offset')[0]) {
        $('.testimonial-slider').slick({
            dots: !0,
            appendDots: $('.testimonial-nav'),
            appendArrows: $('.testimonial-nav'),
            prevArrow: '<span class="slick-prev"><i class="bi bi-arrow-left-short"></i></span>',
            nextArrow: '<span class="slick-next"><i class="bi bi-arrow-right-short"></i></span>',
            responsive: [{
                breakpoint: 768,
                settings: {
                    adaptiveHeight: !0
                }
            }]
        })
    }

    if($('.section-testimonials-center')[0]) {
        $('.testimonial-slider').slick({
            dots: !0,
            appendDots: $('.testimonial-nav'),
            prevArrow: '<span class="slick-prev"><i class="bi bi-arrow-left-short"></i></span>',
            nextArrow: '<span class="slick-next"><i class="bi bi-arrow-right-short"></i></span>',
            responsive: [{
                breakpoint: 768,
                settings: {
                    appendArrows: $('.testimonial-nav'),
                    adaptiveHeight: !0
                }
            }]
        })
    }
}

export const sliderAlumni = () => {
    if($('.section-alumni')[0]) {
        $('.section-alumni .alumni-slider').each(function() {
            const el = $(this)

            el.slick({
                slidesToShow: 3,
                dots: !0,
                appendDots: el.next('.alumni-nav'),
                appendArrows: el.next('.alumni-nav'),
                prevArrow: '<span class="slick-prev"><i class="bi bi-arrow-left-short"></i></span>',
                nextArrow: '<span class="slick-next"><i class="bi bi-arrow-right-short"></i></span>',
                responsive: [{
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    }
                }]
            })
        })
    }
}

export const sliderAuthor = () => {
    if($('.section-authors')[0]) {
        $('.section-authors .authors-slider').each(function() {
            const el = $(this)

            el.on('init', (event, slick) => {
                if(slick.slideCount > 5) {
                    var totalSlides = el.find('.slick-slide').length
                    el.find('.slick-dots').children().show()
                    if(totalSlides > 5) {
                        el.next('.authors-nav').find('.slick-dots').children().slice(5).hide()
                    }
                }
            })

            el.slick({
                slidesToShow: 4,
                dots: !0,
                appendDots: el.next('.authors-nav'),
                appendArrows: el.next('.authors-nav'),
                prevArrow: '<span class="slick-prev"><i class="bi bi-arrow-left-short"></i></span>',
                nextArrow: '<span class="slick-next"><i class="bi bi-arrow-right-short"></i></span>',
                responsive: [{
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        adaptiveHeight: !0
                    }
                }]
            })
    
            el.on('afterChange', function(event, slick, currentSlide) {
                var totalSlides = el.find('.slick-slide').length
                el.next('.authors-nav').find('.slick-dots').children().hide()
                if(totalSlides > 5) {
                    el.next('.authors-nav').find('.slick-dots .slick-active').show()
                    el.next('.authors-nav').find('.slick-dots .slick-active').nextAll('li').slice(0, 4).show()
                }
            })
        })
    }
}

export const sliderCertificationCourse = () => {
    if($('.section-certification-course')[0]) {
        $('.section-certification-course .cols-slider').each(function() {
            const el = $(this)

            el.on('init', (event, slick) => {
                if(slick.slideCount > 5) {
                    var totalSlides = el.find('.slick-slide').length
                    el.find('.slick-dots').children().show()
                    if(totalSlides > 5) {
                        el.next('.cc-nav').find('.slick-dots').children().slice(5).hide()
                    }
                }
            })

            el.slick({
                slidesToShow: 3,
                dots: !0,
                appendDots: el.next('.cc-nav'),
                appendArrows: el.next('.cc-nav'),
                prevArrow: '<span class="slick-prev"><i class="bi bi-arrow-left-short"></i></span>',
                nextArrow: '<span class="slick-next"><i class="bi bi-arrow-right-short"></i></span>',
                responsive: [{
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        adaptiveHeight: !0
                    }
                }]
            })
    
            el.on('afterChange', function(event, slick, currentSlide) {
                var totalSlides = el.find('.slick-slide').length
                el.next('.cc-nav').find('.slick-dots').children().hide()
                if(totalSlides > 5) {
                    el.next('.cc-nav').find('.slick-dots .slick-active').show()
                    el.next('.cc-nav').find('.slick-dots .slick-active').nextAll('li').slice(0, 4).show()
                }
            })
        })
    }
}

export const sliderTabs = () => {
    if($('.section-tabs')[0]) {
        $('.slider-nav').slick({
            asNavFor: '.slider-for',
            slidesToShow: 6,
            infinite: !1,
            arrows: !1,
            focusOnSelect: !0,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }]
        })

        $('.slider-for').slick({
            asNavFor: '.slider-nav',
            arrows: !1,
            fade: !0,
            adaptiveHeight: !0,
            draggable: !1,
            swipe: !1,
            swipeToSlide: !1,
            touchMove: !1,
        })
    }
}

export const sliderPartners = () => {
    if($('.section-partners')[0]) {
        $('.section-partners .partners-row').each(function() {
            const el = $(this)

            if($(window).width() < 768) {
                el.slick({
                    slidesToShow: 1,
                    dots: !0,
                    appendDots: el.next('.partners-nav'),
                    appendArrows: el.next('.partners-nav'),
                    prevArrow: '<span class="slick-prev"><i class="bi bi-arrow-left-short"></i></span>',
                    nextArrow: '<span class="slick-next"><i class="bi bi-arrow-right-short"></i></span>',
                    adaptiveHeight: !0
                })
            }
        })
    }
}

// single certifications
export const sliderImgTxt = () => {
    if($('.slider-2cols-img-txt')[0]) {
        $('.slider-2cols-img-txt .slider-nav').slick({
            asNavFor: '.slider-2cols-img-txt .slider-for',
            slidesToShow: 5,
            arrows: !1,
            focusOnSelect: !0,
            responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    centerMode: !0,
                    centerPadding: '100px',
                }
            }, {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    centerMode: !0,
                    centerPadding: '80px',
                }
            }, {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerMode: !0,
                    centerPadding: '100px',
                }
            }]
        })

        $('.slider-2cols-img-txt .slider-for').slick({
            asNavFor: '.slider-2cols-img-txt .slider-nav',
            dots: !0,
            fade: !0,
            appendDots: $('.img-txt-nav'),
            appendArrows: $('.img-txt-nav'),
            prevArrow: '<span class="slick-prev"><i class="bi bi-arrow-left-short"></i></span>',
            nextArrow: '<span class="slick-next"><i class="bi bi-arrow-right-short"></i></span>',
            adaptiveHeight: !0
        })
    }
}

export const sliderPriceTable = () => {
    if($('.section-price')[0]) {
        if($(window).width() < 992) {
            $('.section-price .slider-nav').slick({
                asNavFor: '.section-price .slider-for',
                slidesToShow: 3,
                infinite: !1,
                arrows: !1,
                focusOnSelect: !0,
            })

            $('.section-price .slider-for').slick({
                asNavFor: '.section-price .slider-nav',
                arrows: !1,
                fade: !0,
                adaptiveHeight: !0,
                draggable: !1,
                swipe: !1,
                swipeToSlide: !1,
                touchMove: !1,
            })
        }
    }
}